export const version = "1.7.21";
export const channel = "core";
export const gitcommit = "unknown";
